import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import CurrencyFormat from './CurrencyFormat';
import ReferralsList from "../containers/ReferralsList";
import axios from "axios";
import * as urls from '../../src/common/urls'
import ReferralCode from "../containers/ReferralCode";

export default function ReferralDashboard() {

    // const { t } = useTranslation();
    const [activeReferralProgramSetting, setActiveReferralProgramSetting] = useState({})
    const [isProgramLoaded, setIsProgramLoaded] = useState(false)

    const getActiveReferralProgramSettings = () => {
      axios.get(urls.GET_ACTIVE_REFERRAL_PROGRAM_SETTING_URL, { headers: {"Content-Type": "application/json"} }).then(response => {
        if(response.status === 200 && response.data) {
          setActiveReferralProgramSetting(response.data);
        }
        setIsProgramLoaded(true)
      });
    }

    useEffect(() => {
      getActiveReferralProgramSettings();
    }, [])

    
    return (
      <Fragment>
        <ReferralCode activeReferralProgramSetting={activeReferralProgramSetting} isProgramLoaded={isProgramLoaded}></ReferralCode>
        <ReferralsList></ReferralsList>
      </Fragment>
        
    );
}
 